import { render } from "./agregarSubAdministrador.vue?vue&type=template&id=ec4f1140&scoped=true"
import script from "./agregarSubAdministrador.vue?vue&type=script&lang=js"
export * from "./agregarSubAdministrador.vue?vue&type=script&lang=js"

import "./agregarSubAdministrador.vue?vue&type=style&index=0&id=ec4f1140&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec4f1140"]])

export default __exports__